export default {
  type: 'menu',
  code: '14000000',
  userManage: {
    type: 'menu',
    code: '14010000'
  },
  roleManage: {
    type: 'menu',
    code: '14020000'
  }
}
